<template>
    <edit-dialog title="绑定设备" :show="show" @close="onClose" width="500px">
        <el-form :model="modelData" label-width="100px" :rules="validRules" ref="frm">
            <el-form-item prop="DeviceSN" label="设备序列号">
                <el-input v-model="modelData.DeviceSN" v-if="isNew" class="inputText"></el-input>
                <el-select v-model="modelData.DeviceID" v-if="!isNew" @change="changeDevice(item)">
                    <el-option v-for="item in dataList" :key="item" :label="item.DeviceSN" :value="item.DeviceID"> </el-option>
                </el-select>
                <el-checkbox v-model="isNew" style="margin-left: 10px">新建</el-checkbox>
            </el-form-item>
            <el-form-item prop="DeviceName" label="设备名称">
                <el-input v-model="modelData.DeviceName" class="inputText"></el-input>
            </el-form-item>
            <el-form-item prop="DeviceModel" label="设备型号">
                <el-input v-model="modelData.DeviceModel" class="inputText"></el-input>
            </el-form-item>
        </el-form>
        <template v-slot:button>
            <el-button type="success" @click="saveData"> 保存 </el-button>
            <el-button type="info" @click="onClose"> 取消 </el-button>
        </template>
    </edit-dialog>
</template>
<script>
export default {
    name: "BindDevice",
    props: {
        show: { type: Boolean, default: false },
    },
    data() {
        return {
            isNew: false,
            dataList: [],
            modelData: {
                DeviceID: "",
                DoorID: "",
                DeviceSN: "",
                DeviceName: "",
                DeviceModel: "",
                Memo: "",
            },
            validRules: {
                DeviceSN: [
                    {
                        required: true,
                        message: "请选择或填写设备序列号",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        this.getList();
    },
    methods: {
        changeDB(item) {
            this.modelData.DeviceSN = item.DeviceSN;
        },
        getList() {
            let url = this.$route.query.tid ? "/Tenant/GetNoBindDevice?tid=" + this.$route.query.tid : "/Entity/GetNoBindDevice";
            this.$ajax.post(url, {}).then((res) => {
                this.dataList = res.Data;
                if (this.dataList.length > 0) {
                    this.modelData.DeviceID = this.dataList[0].DeviceID;
                    this.modelData.DeviceSN = this.dataList[0].DeviceSN;
                }
            });
        },
        onClose() {
            this.$emit("close");
        },
        saveData() {
            if (this.isNew) {
                this.modelData.DeviceID = "";
            }
            this.$refs.frm.validate((r) => {
                if (r) {
                    this.$emit("save", this.modelData);
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
<style scoped>
.inputText {
    width: 220px;
}
</style>
